import { FIELD, SIGNED_INTEGER_FORMAT } from "./constants";

const TABLE = "WMTRANSACTIONHEADER";

/**
 * The single group reproduces the legacy form's left group box (grpBottomLeft in uWMD0094.dfm), caption
 * verbatim. Field order is the Delphi top-to-bottom order, taken from the DFM Top values:
 * cmbMethod, edtDay, edtSlidingDays, cmbStatus.
 *
 * The right-hand group box ("Additional Information") is NOT a form group — it is two read-only TMemos,
 * so the page renders it beside this panel rather than as a schema group.
 *
 * Captions are the Delphi captions verbatim, including their inconsistent capitalisation ("Day of Next
 * Month" with a lower-case "of" next to "# Of Days From Trans. Date"). Do not normalise them.
 *
 * isLabelChanged: true everywhere so Fields.js uses the literal label instead of a Localization lookup —
 * these captions must match the Delphi form and no localization keys exist for them.
 *
 * required:
 *  - the two selects are required and always populated (both have defaults), so the static RequiredRule
 *    Fields.js emits can never be wrong;
 *  - BOTH numerics are required:false, and that is load-bearing rather than laziness. Blank is a LEGAL
 *    state for each of them in Delphi — it is exactly what Start confirmations 2 and 3 exist to handle —
 *    and Fields.js has no conditional-required. The Day range is applied by the page's
 *    clampDayOfNextMonth and again server-side by [Range] on the request DTO.
 *
 * `format` is honoured by Fields.js for type "number" only, which is what both numerics are. There is
 * no min/max passthrough, which is why the range lives in the page.
 */
const ParametersLayout = [
    {
        groupId: 1,
        label: "Parameters",
        fields: [
            {
                name: FIELD.DateMethod,
                tableName: TABLE,
                label: "Transaction Date Method",
                type: "select",
                required: true,
                visible: true,
                isLabelChanged: true,
            },
            {
                name: FIELD.DayOfNextMonth,
                tableName: TABLE,
                label: "Day of Next Month",
                type: "number",
                format: SIGNED_INTEGER_FORMAT,
                required: false,
                visible: true,
                isLabelChanged: true,
            },
            {
                name: FIELD.SlidingDays,
                tableName: TABLE,
                label: "# Of Days From Trans. Date",
                type: "number",
                format: SIGNED_INTEGER_FORMAT,
                required: false,
                visible: true,
                isLabelChanged: true,
            },
            {
                name: FIELD.Status,
                tableName: TABLE,
                label: "Status",
                type: "select",
                required: true,
                visible: true,
                isLabelChanged: true,
            },
        ],
    },
];

export { ParametersLayout };
